var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("images")))]),
              _c(
                "w-list",
                [
                  _vm._l(_vm.layout.Images, function (image, i) {
                    return _c(
                      "w-list-item",
                      { key: image.key },
                      [
                        _c("w-list-item-icon", [
                          _c("span", {
                            staticClass: "thumbnail",
                            style: {
                              backgroundImage: `url(${encodeURI(
                                image.getEditorImageUrl()
                              )})`,
                            },
                          }),
                        ]),
                        _c("w-list-item-text", { staticClass: "image-name" }, [
                          _vm._v(" " + _vm._s(image.getName(_vm.model)) + " "),
                        ]),
                        _c(
                          "w-list-item-action",
                          [
                            !image.UseImageToken
                              ? _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("edit-image"),
                                        expression: "$ct('edit-image')",
                                      },
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.editImage(image)
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "pen" } })],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("delete-image"),
                                    expression: "$ct('delete-image')",
                                  },
                                ],
                                staticClass: "danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteImage(i)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "trash" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "w-list-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addNewImage()
                        },
                      },
                    },
                    [
                      _c(
                        "w-list-item-icon",
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _c("w-list-item-text", [
                        _vm._v(" " + _vm._s(_vm.$ct("create-new-image")) + " "),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.toEditImageIndex != -1
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-image-settings", {
                attrs: { model: _vm.model, layout: _vm.layout },
                on: {
                  close: function ($event) {
                    _vm.toEditImageIndex = -1
                  },
                },
                model: {
                  value: _vm.layout.Images[_vm.toEditImageIndex],
                  callback: function ($$v) {
                    _vm.$set(_vm.layout.Images, _vm.toEditImageIndex, $$v)
                  },
                  expression: "layout.Images[toEditImageIndex]",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.newImageModalOpen
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c(
                "w-card",
                { attrs: { "max-width": "500" } },
                [
                  _c(
                    "w-card-title",
                    [
                      _vm._v(" " + _vm._s(_vm.$ct("create-new-image")) + " "),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          attrs: { white: "" },
                          on: {
                            click: function ($event) {
                              _vm.newImageModalOpen = false
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list",
                    [
                      _c(
                        "w-list-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openSelectImageModal()
                            },
                          },
                        },
                        [
                          _c("w-list-item-text", [
                            _vm._v(_vm._s(_vm.$ct("static-image"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.createNewImageFromProperty()
                            },
                          },
                        },
                        [
                          _c("w-list-item-text", [
                            _vm._v(
                              _vm._s(_vm.$ct("image-source-from-property"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.newImageAwsTokenModalOpen
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-images-list", {
                on: {
                  close: function ($event) {
                    _vm.newImageAwsTokenModalOpen = false
                  },
                  img: function ($event) {
                    return _vm.createNewStaticImage($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }